// extracted by mini-css-extract-plugin
export var clauseRow = "_bn-6";
export var emptyState = "_bn-d";
export var filterContent = "_bn-a";
export var filterGroup = "_bn-1";
export var filterGroupContainer = "_bn-0";
export var nestedGroup = "_bn-2";
export var nestedGroupContent = "_bn-b";
export var nestedGroupDepth1 = "_bn-3";
export var nestedGroupDepth2 = "_bn-4";
export var nestedGroupDepth3 = "_bn-5";
export var nestedGroupEmpty = "_bn-c";
export var operatorAnd = "_bn-8";
export var operatorOr = "_bn-9";
export var operatorToggle = "_bn-7";
export var removeGroupButton = "_bn-e";